import { ArrowLeft, Home } from "lucide-react";
import { Link } from "react-router-dom";

import { AppShell } from "../../components/app-shell.js";

export function NotFoundPage(): React.JSX.Element {
  return (
    <AppShell mainClassName="not-found-screen">
      <section className="not-found-card">
        <span className="section-kicker">A quiet dead end</span>
        <h1>This page could not be found</h1>
        <p>The link may be out of date. Your learning data is still safe.</p>
        <div>
          <Link className="primary-button" to="/today">
            <Home size={16} /> Go to Today
          </Link>
          <Link className="text-button" to="/library">
            <ArrowLeft size={16} /> Open Library
          </Link>
        </div>
      </section>
    </AppShell>
  );
}
